import React from 'react';
import { TransactionData } from '../utils/transactionUtils';
import { TransactionListItem } from './TransactionListItem';

interface TransactionListProps {
  transactions: TransactionData[];
  selectedTransaction: TransactionData | null;
  isLoading: boolean;
  leftSideRef: React.RefObject<HTMLDivElement>;
  onTransactionSelect: (transaction: TransactionData) => void;
}

export const TransactionList: React.FC<TransactionListProps> = ({
  transactions,
  selectedTransaction,
  isLoading,
  leftSideRef,
  onTransactionSelect,
}) => (
  <div
    className='flex-[2] border-r border-[#DEE2EF] overflow-y-auto h-full scrollbar-hide'
    ref={leftSideRef}
  >
    {transactions.map((transaction, index) => (
      <TransactionListItem
        key={`${transaction.date}-${index}`}
        transaction={transaction}
        isSelected={transaction.transactionId === selectedTransaction?.transactionId}
        onClick={() => onTransactionSelect(transaction)}
      />
    ))}
    {isLoading && <div className='p-4 text-center'>Loading more...</div>}
  </div>
);

